import { UsersEntryType } from "components/views/users/types";

import { ExhUserListItem } from "../types";

export const exhUserToUsersEntry = (user: ExhUserListItem): UsersEntryType => {
  const roleNames = (user.staffEnlistments ?? [])
    .flatMap((enlistment) => enlistment.roles ?? [])
    .map((role) => role.name)
    .filter((name): name is string => Boolean(name));

  const uniqueRoleNames = Array.from(new Set(roleNames));

  return {
    id: user.id,
    email: user.email ?? "",
    firstName: user.firstName ?? "",
    lastName: user.lastName ?? "",
    role: uniqueRoleNames.length > 0 ? { name: uniqueRoleNames.join(", ") } : null,
  };
};
